// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gacb","top":"styles_top__MQW21","left":"styles_left__22wqJ","description":"styles_description__2FEAs"};